<template>
  <div class="ai-platform-page">
    <div class="ai-hero-banner">
      <img src="@/assets/jiejue/storage/top.svg" alt="" srcset="" style="width: 100%" @load="loaded = true" :class="{ show: loaded }" class="top_img">
      <div class="ai-hero-title">云存储安全解决方案</div>
    </div>

    <nav class="product-tabs-bar">
      <a class="product-tab" :class="{ active: activeTab === 'background' }" href="#background" @click.prevent="scrollTo('background')">需求背景</a>
      <a class="product-tab" :class="{ active: activeTab === 'challenges' }" href="#challenges" @click.prevent="scrollTo('challenges')">业务挑战</a>
      <a class="product-tab" :class="{ active: activeTab === 'scenarios' }" href="#scenarios" @click.prevent="scrollTo('scenarios')">场景应用</a>
      <a v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" class="product-tab" :class="{ active: activeTab === 'architecture' }" href="#architecture" @click.prevent="scrollTo('architecture')">部署示意图</a>
      <a class="product-tab" :class="{ active: activeTab === 'advantages' }" href="#advantages" @click.prevent="scrollTo('advantages')">方案优势</a>
      <a class="product-tab" :class="{ active: activeTab === 'cases' }" href="#cases" @click.prevent="scrollTo('cases')">典型案例</a>
    </nav>

    <div class="product-body">
    <section id="background" class="product-section section-row ai-platform-block" :class="{ 'animate-in': backgroundVisible }">
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            云存储安全解决方案专注于为云租户提供统一管理、统一运维、按需扩展的安全资源池能力。随着云计算的快速发展，传统安全防护手段难以满足多租户场景下的安全需求。方案将安全能力以资源池形式与云平台深度集成，提供统一登录、统一配置、统一引流，满足等保二级、三级要求，保障云租户业务系统在云上安全可靠运行，实现云平台内资产、威胁、行为100%可知可见。
          </p>
        </div>
      </div>
    </section>

    <section id="challenges" class="product-section section-row ai-platform-block" :class="{ 'animate-in': challengesVisible }">
      <div class="section-title">业务挑战</div>
      <div class="section-content">
      <div class="grid-2">
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/storage/1.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">基础设施与虚拟化安全风险</div>
            <div class="card-desc">私有云依赖的物理服务器、存储设备若存在硬件故障或配置漏洞，可能导致服务中断；虚拟化层（如 KVM、VMware）的漏洞可能引发虚拟机逃逸、镜像投毒等问题，破坏租户（内部部门）间的隔离边界，威胁核心业务系统安全。</div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/storage/2.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">身份认证与访问控制漏洞</div>
            <div class="card-desc">内部用户、管理员权限划分模糊，易出现超权限操作、离职人员权限未及时回收等情况；针对动态扩容的云资源（如临时计算节点），静态权限配置难以适配，可能形成权限管控盲区，为内部越权访问或恶意操作提供可乘之机。</div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/storage/3.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">数据全生命周期管控不足</div>
            <div class="card-desc">数据在私有云内的存储、传输、备份环节可能存在加密覆盖不全的问题，敏感数据易被非法窃取；多副本存储的管理不当的问题，以及资源释放后的数据残留问题，可能导致数据泄露；同时，内部人员误操作或恶意拷贝，也会加剧数据安全风险。</div>
          </div>
        </div>
        <div class="card">
          <img class="card-icon" src="@/assets/jiejue/storage/4.svg" alt="icon" />
          <div class="card-text">
            <div class="card-title">安全监控与应急响应滞后</div>
            <div class="card-desc">私有云的日志分散在不同节点和设备中，难以实现统一采集与关联分析，易出现威胁检测盲区；面对勒索软件、内部攻击等高级威胁，传统安全工具的检测能力有限，且应急响应流程缺乏实战化打磨，可能导致安全事件处置延迟，扩大损失范围。</div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section id="scenarios" class="product-section section-row ai-platform-block" :class="{ 'animate-in': scenariosVisible }">
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <div class="scenario-item">
    
            <div class="item-desc">随着云计算的快速发展，传统的安全防护手段逐渐无法满足用户在云计算环境下的安全需求。在云计算多租户场景中，租户通常会根据自身业务需求和安全合规要求进行顶层安全设计。当前云平台能提供的安全措施屈指可数，租户顶层安全设计难以落地，业务系统安全难以保障。中国云信任报告显示：安全成为租户业务上云的最大顾虑。安全资源池专注于为云租户提供丰富的安全功能，保障云租户业务系统在云上安全可靠地运行。</div>
          </div>

        </div>
        <!-- <div class="scenario-image" aria-label="AI 芯片示意图"></div> -->
         <img src="@/assets/jiejue/storage/right.svg" alt="" style="width: 50%; border-radius: 4px;" class="mobile-hidden-img">
      </div>
      </div>
    </section>

    <section v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM" id="architecture" class="product-section section-row ai-platform-block" :class="{ 'animate-in': architectureVisible }">
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img src="@/assets/solutions/deploy/storage.svg" alt="部署示意图" class="architecture-image">
      </div>
    </section>

    <section id="advantages" class="product-section section-row advantages ai-platform-block" :class="{ 'animate-in': advantagesVisible }">
      <div class="section-title">方案优势</div>
      <div class="section-content">
      <div class="grid-4">
        <div class="adv-card">
          <!-- <div class="adv-badge">1</div> -->
           <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge"/>
          <div class="adv-title">统一管理</div>
          <div class="adv-desc">提供资源池内安全产品的统一登录、统一配置、统一引流，为云服务方统一管理提供了支撑平台</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge"/>
          <div class="adv-title">统一运维</div>
          <div class="adv-desc">提供对平台自身各组件，以及云安全资源池内的宿主机、安全网元等全方位监控能力。包括对组件的健康度监控、配置信息监控、性能负载监控等</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge"/>
          <div class="adv-title">按需扩展</div>
          <div class="adv-desc">云安全资源池可根据云租户的增加、业务的增加，按需扩展安全能力</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge"/>
          <div class="adv-title">满足安全合规要求</div>
          <div class="adv-desc">从虚拟化网络边界到入侵检测和防范，以及统一安全管理，满足等保二级、三级要求</div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/5.svg" alt="" class="adv-badge"/>
          <div class="adv-title">安全可管可控</div>
          <div class="adv-desc">云平台内所有资产状态、威胁情况、行为情况等，100%可知可见</div>
        </div>
      </div>
      </div>
    </section>

    <section id="cases" class="product-section section-row ai-platform-block" :class="{ 'animate-in': casesVisible }">
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某省信息中心按照“集约高效、共享开放、安全可靠、按需服务”的原则，构建省级电子政务云平台，实现市政府各部门基础设施共建共用、数据资源汇聚共享、业务应用有效协同。该政务云平台覆盖政务外网、互联网两大区域，承载着420个云租户的业务系统，涉及政务服务、公共资源交易、城市治理等多个核心领域，需按照网络安全等级保护三级标准进行建设。当前，政务云平台面临的核心安全挑战是：租户数量多、业务场景复杂，需实现租户间的安全隔离，防止数据泄露；政务数据量大、敏感信息多，需保障数据传输、存储、使用全流程安全；安全设备分散，缺乏统一的安全管控和态势感知能力，难以快速发现和处置安全威胁；需满足等保三级合规要求，支撑政务云平台的安全稳定运行。为此，该省信息中心引入政务云安全解决方案，构建全方位的政务云安全防护体系。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 租户隔离与数据安全保障难：420个云租户共享政务云资源，需实现租户间的物理隔离和逻辑隔离，防止跨租户数据泄露，同时保障政务敏感数据的全流程安全；</li>
              <li>2. 安全防护体系不完整：政务云涵盖外网、互联网两大区域，需实现边界防护、主机防护、应用防护、安全审计等全流程防护，现有安全能力存在短板；</li>
              <li>3. 安全态势感知能力弱：缺乏统一的安全态势展示和分析平台，无法实时掌握政务云整体安全状态，安全威胁发现不及时、处置效率低；</li>
              <li>4. 合规要求高：需严格按照等保三级标准建设，同时满足政务数据安全、个人信息保护等相关法规要求，合规整改难度大。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 构建租户隔离与数据安全体系：采用虚拟化分布式防火墙技术，实现各租户间的逻辑隔离，同时部署数据加密、数据脱敏等安全组件，对政务敏感数据进行全流程加密保护，确保数据“可用不可见”；严格控制租户访问权限，采用最小权限原则，防止跨租户越权访问。</li>
              <li>2. 搭建全方位纵深防御体系：在政务外网区域部署云数据库审计系统、集中日志审计系统、应用安全审计系统；在互联网区域部署云堡垒机、云数据库审计系统和网页访问监控系统；同时部署虚拟化WEB应用防火墙、入侵检测与防护、下一代防火墙、防病毒等安全产品，实现从边界、主机、应用到审计的全流程防护。</li>
              <li>3. 强化安全态势感知与处置：搭建统一的安全态势大屏，集中采集政务云平台所有安全设备的日志、流量数据，采用大数据引擎进行集中挖掘、关联分析及追踪溯源，实时展示安全威胁态势，实现安全威胁的快速发现、告警和处置；建立安全应急响应机制，确保突发安全事件能够及时处置，保障业务连续性。</li>
              <li>4. 满足合规要求：按照等保三级标准优化安全架构，完善身份鉴别、访问控制、安全审计、软件容错等功能，补全安全短板；定期开展等保自评和漏洞扫描，及时整改安全隐患，生成合规审计报表，确保政务云平台及租户业务系统顺利通过等保三级测评，满足政务数据安全合规要求。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
const loaded = ref(false)

const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

// 这里写即可，代替 export default
defineOptions({
  banner: new URL('../../assets/jiejue/storage/top.svg', import.meta.url).href
})
const activeTab = ref('background')
const isScrollingProgrammatically = ref(false) // 添加标志，防止程序滚动时覆盖activeTab
const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  
  // 立即设置activeTab，确保点击时立即高亮
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  
  // 设置标志，表示这是程序触发的滚动
  isScrollingProgrammatically.value = true
  
  // 滚动到目标元素
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  
  // 滚动完成后，重置标志，允许IntersectionObserver再次工作
  setTimeout(() => {
    isScrollingProgrammatically.value = false
    // 确保滚动后activeTab正确
    updateActiveTab()
  }, 800) // 减少时间，从1000ms改为800ms
}
const animationObserver = ref(null)
const navObserver = ref(null) // 添加导航观察器
let scrollTimeout = null

const updateActiveTab = () => {
  // 如果是程序触发的滚动，不更新
  if (isScrollingProgrammatically.value) {
    console.log('Skipping update due to programmatic scroll')
    return
  }
  
  const sections = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  const scrollPosition = window.scrollY
  let newActiveTab = 'background'
  
  // 遍历所有区块，找出当前滚动位置对应的区块
  for (let i = 0; i < sections.length; i++) {
    const section = document.getElementById(sections[i])
    if (section) {
      const rect = section.getBoundingClientRect()
      const sectionTop = rect.top + window.scrollY
      const sectionBottom = sectionTop + rect.height
      
      // 如果当前滚动位置在区块范围内
      if (scrollPosition >= sectionTop - 150 && scrollPosition < sectionBottom - 150) {
        newActiveTab = sections[i]
        break
      }
    }
  }
  
  // 更新activeTab
  if (activeTab.value !== newActiveTab) {
    console.log('Updating activeTab from', activeTab.value, 'to', newActiveTab, 'scrollY:', scrollPosition)
    activeTab.value = newActiveTab
    history.replaceState(null, '', `#${newActiveTab}`)
  }
}

const handleScroll = () => {
  // 清除之前的定时器
  if (scrollTimeout) clearTimeout(scrollTimeout)
  
  // 设置新的定时器，延迟更新
  scrollTimeout = setTimeout(() => {
    console.log('Scroll event triggered, scrollY:', window.scrollY)
    updateActiveTab()
  }, 50)
}

// 添加一个立即执行的版本，用于测试
const handleScrollImmediate = () => {
  console.log('Scroll event triggered (immediate), scrollY:', window.scrollY)
  updateActiveTab()
}

// 使用IntersectionObserver来检测当前可见的区块
const setupIntersectionObserver = () => {
  // 创建观察器，设置阈值为0.5，表示当区块50%可见时触发
  navObserver.value = new IntersectionObserver((entries) => {
    // 如果是程序触发的滚动，不更新
    if (isScrollingProgrammatically.value) {
      console.log('IntersectionObserver: Skipping update due to programmatic scroll')
      return
    }
    
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const sectionId = entry.target.id
        console.log('IntersectionObserver: Section', sectionId, 'is intersecting')
        
        // 更新activeTab
        if (activeTab.value !== sectionId) {
          console.log('IntersectionObserver: Updating activeTab from', activeTab.value, 'to', sectionId)
          activeTab.value = sectionId
          history.replaceState(null, '', `#${sectionId}`)
        }
      }
    })
  }, {
    threshold: 0.2, // 当区块20%可见时触发
    rootMargin: '-100px 0px -60% 0px' // 从顶部100px和底部60%的偏移
  })
  
  // 观察所有区块
  const sections = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  sections.forEach(sectionId => {
    const section = document.getElementById(sectionId)
    if (section) {
      navObserver.value.observe(section)
    }
  })
}

onMounted(() => {
  activeTab.value = 'background'
  console.log('Initial activeTab set to:', activeTab.value)
  
  // 延迟设置IntersectionObserver，确保DOM已完全加载
  setTimeout(() => {
    console.log('Setting up IntersectionObserver')
    setupIntersectionObserver()
    
    // 初始调用一次updateActiveTab
    console.log('Initial call to updateActiveTab')
    updateActiveTab()
  }, 300)
  
  // 创建动画观察器
  animationObserver.value = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const targetId = entry.target.id;
        if (targetId === 'background') backgroundVisible.value = true;
        if (targetId === 'challenges') challengesVisible.value = true;
        if (targetId === 'scenarios') scenariosVisible.value = true;
        if (targetId === 'architecture') architectureVisible.value = true;
        if (targetId === 'advantages') advantagesVisible.value = true;
        if (targetId === 'cases') casesVisible.value = true;
      }
    });
  }, {
    rootMargin: '-10% 0px -10% 0px',
    threshold: 0.1
  });

  // 观察所有区块元素
  const observeBlocks = () => {
    const blocks = document.querySelectorAll('.ai-platform-block');
    blocks.forEach(block => {
      animationObserver.value.observe(block);
    });
  };
  
  observeBlocks();
  
  // 添加滚动事件监听器作为备用方案
  console.log('Adding scroll event listener (immediate)')
  window.addEventListener('scroll', handleScrollImmediate, { passive: true })
})

onBeforeUnmount(() => { 
  // 清理IntersectionObserver
  if (navObserver.value) {
    console.log('Disconnecting navObserver')
    navObserver.value.disconnect()
  }
  
  if (animationObserver.value) animationObserver.value.disconnect()
  if (scrollTimeout) clearTimeout(scrollTimeout)
  window.removeEventListener('scroll', handleScrollImmediate)
  console.log('Scroll event listener removed')
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s ease;
}

.background-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.case-content {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
}

.section-content-cases {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(6, 85, 159, 0); }
  50% { opacity: 0.88; box-shadow: 0 0 28px rgba(6, 85, 159, 0.25); }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
}

.hero {
  position: relative;
  height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(110deg, #eaf2ff 0%, #f7fbff 40%, #eef5ff 60%, #dfeaff 100%);
  overflow: hidden;
}

.hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(1200px 360px at 75% 20%, rgba(24,144,255,0.18) 0%, rgba(24,144,255,0) 60%),
              radial-gradient(800px 300px at 20% 80%, rgba(64,158,255,0.20) 0%, rgba(64,158,255,0) 60%);
}

.hero-inner {
  position: relative;
  z-index: 1;
  max-width: 1100px;
  padding: 0 24px;
  text-align: left;
}

.hero-inner h1 {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 18px;
  color: #0f172a;
}

.hero-inner p {
  font-size: 16px;
  line-height: 1.7;
  color: #333;
}

.block { 
      scroll-margin-top: 120px;
    max-width: 1420px;
    margin: 0 auto;
    padding: 60px 20px 90px 20px;
 }


.grid-2 { display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; }
.grid-4 { display: grid; grid-template-columns: repeat(5, 1fr); gap: 20px; }

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background:  #F5F7FA;;
  /* border: 1px solid #E6EBF5; */
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon { flex-shrink: 0; }
.card-text { display: flex; flex-direction: column;text-align: start; }
.card-title { 
  font-family: PingFang SC;
font-size: 18px;
font-weight: 600;
line-height: normal;
letter-spacing: 0em;

font-variation-settings: "opsz" auto;
color: #000000;
line-height: 40px;
 }
.card-desc { font-size: 14px; line-height: 1.7; color: #666; }

.scenarios {
  display: flex;
  /* grid-template-columns: minmax(0, 1fr) 629px; */
  /* gap: 0; */
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  /* box-shadow: 0px 3px 6px 0px #EBEFF7; */
  padding: 50px 0px 0px 40px;
  /* height: 369px; */
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-item { margin-bottom: 18px; }
.scenario-item .item-title { font-size: 16px; line-height: 16px; color: #333; margin-bottom: 8px;font-family: PingFang SC; }
.scenario-item .item-desc { font-size: 14px; line-height: 1.8; color: #666; }
/* .scenario-item.highlight .item-title { color: #FF6A00; } */

.scenario-image {
  background-image: url('../../assets/jiejue/ai-tiaozhan/1.jpg');
  background-size: cover;
  background-position: center;
  border-radius: 6px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 629px;
  height: 369px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.scenario-image::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.85) 40%, rgba(255,255,255,0) 100%);
  pointer-events: none;
}

.diagram { display: grid; gap: 12px; }
.layer { background: #fff; border: 1px solid #e6ebf5; border-radius: 6px; }
.layer-title { padding: 10px 14px; font-size: 14px; color: #333; background: #f6f9ff; border-color: #dfe8ff; }
.layer-title.blue { background: #e8f2ff; border-color: #cfe0ff; }
.grid.layer-app { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; padding: 12px; }
.grid.layer-ml { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-data { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-infra { display: grid; grid-template-columns: repeat(5, 1fr); gap: 8px; padding: 12px; }
.grid.layer-app > div,
.grid.layer-ml > div,
.grid.layer-data > div,
.grid.layer-infra > div { background: #f9fbff; border: 1px dashed #e1e9ff; border-radius: 6px; padding: 12px; text-align: center; font-size: 13px; }

@media (max-width: 1200px) {
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .product-body { padding: 0 16px 40px; }
  .grid-2 { grid-template-columns: 1fr; }
  .grid-4 { grid-template-columns: 1fr; }
  .grid.layer-ml,
  .grid.layer-data,
  .grid.layer-infra { grid-template-columns: repeat(2, 1fr); }
  .scenario-image { width: 100%; height: 280px; }
  .scenario-text { height: auto; border-radius: 6px; }
}

.fade-enter-active, .fade-leave-active { transition: opacity .25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
#advantages { background: linear-gradient(180deg, #F5F7FA 0%, #E0ECFF 100%);max-width: unset; }
.advantages .grid-4 { align-items: stretch; gap: 20px; max-width: 1770px; margin: 0 auto; }
.adv-card { min-height:240px;position: relative; background: #fff;  border-radius: 4px;  padding: 29px; padding-top: 70px; display: flex; flex-direction: column; box-sizing: border-box; text-align: start; }
.adv-badge { position: absolute; top: 33px; left: 29px; width: 24px; height: 24px; border-radius: 4px; background: #1890FF; color: #fff; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 600; }
.adv-title { font-size: 16px; font-family: PingFang SC; color: #333; margin-bottom: 10px; font-weight: 600; }
.adv-desc { font-size: 14px; line-height: 1.6; color: #333; }
.main-content{
  background: #fff;
}
#scenarios{
  max-width: unset;
  background: #F5F7FA;

  /* max-width: 1182px; */
}

@media (max-width: 576px) {
  .product-tabs-bar {
    gap: 20px;
  }
}
</style>

